// extracted by mini-css-extract-plugin
export var fadeInAnimation = "text-module--fadeInAnimation--ad317";
export var icon = "text-module--icon--c0df6";
export var text = "text-module--text--0b235";
export var title = "text-module--title--90d72";
export var wrapper = "text-module--wrapper--11088";